export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/AL-1280cd3934a0ff1bafc5abe059e14e0c.PNG";